import { EventProps } from '../product/product-view.props';
import { VehicleOffersEventDescription } from '../../hooks/react-query/use-vehicle-offers-event-descriptions/use-vehicle-offers-event-descriptions.types';

export const getMajorEventDescription = (eventDescriptions: VehicleOffersEventDescription[], events: EventProps[]) => {
  if (!events.length || !eventDescriptions.length) {
    return null;
  }
  let majorEventDescription = eventDescriptions.sort((a, b) => (a.uds_hierarchie || 0) - (b.uds_hierarchie || 0))[0];
  events.forEach(event => {
    const eventDescriptionId = event.uds_eventdescription?.id;
    const eventDescription = eventDescriptions.find(
      eventDescription => eventDescription.uds_fahrzeugbestellungeneventdescriptionid === eventDescriptionId
    );

    if (eventDescription && (eventDescription.uds_hierarchie || 0) > (majorEventDescription.uds_hierarchie || 0)) {
      majorEventDescription = eventDescription;
    }
  });

  return majorEventDescription;
};

export const getMinorEventDescription = (eventDescriptions: VehicleOffersEventDescription[], events: EventProps[]) => {
  if (!events.length || !eventDescriptions.length) {
    return null;
  }
  let minorEventDescription = eventDescriptions.sort((a, b) => (b.uds_hierarchie || 0) - (a.uds_hierarchie || 0))[0];
  events.forEach(event => {
    const eventDescriptionId = event.uds_eventdescription?.id;
    const eventDescription = eventDescriptions.find(
      eventDescription => eventDescription.uds_fahrzeugbestellungeneventdescriptionid === eventDescriptionId
    );

    if (eventDescription && (eventDescription.uds_hierarchie || 0) < (minorEventDescription.uds_hierarchie || 0)) {
      minorEventDescription = eventDescription;
    }
  });

  return minorEventDescription;
};

export function takeStatusSectionLatestEvent(events: EventProps[]) {
  if (!events.length) {
    return undefined;
  }

  return events.sort((a, b) => new Date(b.createdon.value).getTime() - new Date(a.createdon.value).getTime())[0];
}

export function takeStatusSectionOldestEvent(events: EventProps[]) {
  if (!events.length) {
    return undefined;
  }

  return events.sort((a, b) => new Date(a.createdon.value).getTime() - new Date(b.createdon.value).getTime())[0];
}
